<top-navigation class="d-print-none"></top-navigation>

<main>
    <main-banner [title]="headerArticle.title" [description]="headerArticle.bodyText"></main-banner>

    <contact-us-contact-center></contact-us-contact-center>

    <contact-resources></contact-resources>
</main>

<app-footer></app-footer>
